import { render, staticRenderFns } from "./HWP_Modal_Accounting_Salary_Charge.vue?vue&type=template&id=bd6aa74a&scoped=true&"
import script from "./HWP_Modal_Accounting_Salary_Charge.vue?vue&type=script&lang=js&"
export * from "./HWP_Modal_Accounting_Salary_Charge.vue?vue&type=script&lang=js&"
import style0 from "./HWP_Modal_Accounting_Salary_Charge.vue?vue&type=style&index=0&id=bd6aa74a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6aa74a",
  null
  
)

export default component.exports